import React from "react";
import { Routes, Route, Navigate } from "react-router";
import { WrongPath } from "./WrongPath";
import { LoginPage } from "./Components/Login/LoginPage";
import { CheckAuth } from "./auth/CheckAuth";
import { LoginKeeper } from "./auth/LoginKeeper";
import UsersListing from "./Components/Users/UsersListing";
import { Backdrop } from "@mui/material";
import { Triangle } from "react-loader-spinner";
import { useSelector } from "react-redux";
import AddTheme from "./Components/AddTheme/AddTheme";
import Eventmanagement from "./Components/EventManagement/Eventmanagement";
import DropdownWithEditDelete from "./Components/testing";
import HomeAutomation from "./Components/Users/HomeAutomation";
import Subscribers from "./Components/Users/Subscribers";
import ViewUsers from "./Components/View/ViewUsers";
import ChannelManagement from "./Components/ChannelManagement/ChannelManagement";
import ChannelView from "./Components/View/ChannelView";
import Banners from "./Pages/Banners/Banners";
// import Banners from "./Pages/AdvatismentBanner/Banners";
import PackageListing from "./Pages/Packages/PackageListing";
import { GenreListing } from "./Pages/Genre/GenreListing";
import Languages from "./Pages/Languages/Languages";
import Broadcaster from "./Pages/Broadcaster/Broadcaster";
import Categories from "./Pages/Categories/Categories";
import TVBanner from "./Pages/Banners/TVBanner";
import PrivacyPolicy from "./Pages/teams_Policy/PrivacyPolicy";
import TermsConditions from "./Pages/teams_Policy/TermsConditions";
import AboutUsPage from "./Pages/teams_Policy/AboutUs";
import AdBanners from "./Pages/AdvatismentBanner/AdBanners";
import AdTVBanner from "./Pages/AdvatismentBanner/AdTVBanner";
import TVSlider from "./Pages/Banners/TVSlider";
import ChannelCategory from "./Pages/ChannelCategory/ChannelCategory";
import FreeLiveChannelList from "./Pages/FreeLiveChannel/FreeLiveChannelList";
import AppVersionList from "./Pages/AppVersion/AppVersionList";
import AppVersionMobileList from "./Pages/AppVersionMobile/AppVersionMobileList";
import DeleteUser from "./Components/DeleteUser/DeleteUser";
import ChannelLanguageList from "./Pages/channelLanguage/ChannelLanguageList";
import AddChannelLanguage from "./Pages/channelLanguage/AddChannelLanguage";
import TermAndConditions from "./Pages/cms/TermAndConditions";
import AboutUs from "./Pages/cms/AboutUs";
import Policy from "./Pages/cms/Policy";
import DeleteNewSubscriber from "./Components/DeleteNewSubscriber/DeleteNewSubscriber";
import DeletedUsersList from "./Components/DeleteNewSubscriber/DeletedUsersList";
import IptvChannelList from "./Pages/IptvChannel/IptvChannelList";
import IptvUserRequest from "./Pages/iptvUsers/IptvUserRequest";
import ContactUs from "./Pages/cms/ContactUs";
import Dashboard from "./Components/Dashboard/Dashboard";
import AdsBanner from "./Pages/adsBanner/AdsBanner";
import OttContent from "./Pages/ottHub/OttHubContentList";
// import SecurityCheck from "./Pages/securityCheck/SecurityCheck";
import { ProtectedRoute } from "./auth/ProtectedRoute";

export const Router = () => {
  let loader = useSelector((e) => e.loader);
  return (
    <>
      <Backdrop sx={{ color: "#fff", zIndex: 99999999999 }} open={loader}>
        <Triangle
          height="80"
          width="80"
          color="black"
          ariaLabel="triangle-loading"
          visible={loader}
        />
      </Backdrop>

      <Routes>
        <Route path="/policy" element={<Policy />} />
        <Route path="/termAndConditons" element={<TermAndConditions />} />
        <Route path="/aboutUs" element={<AboutUs />} />
        <Route path="/contactUs" element={<ContactUs />} />
        <Route path="/delete-account" element={<DeleteNewSubscriber />} />

        <Route>
          <Route path="/login" element={<LoginPage />} />
        </Route>

        <Route element={<ProtectedRoute />}>
          {/* <Route exact path="/qrcode" element={<Qrcode />} /> */}
          <Route path="/delete-user" element={<DeleteUser />} />
          <Route path="/deleted-users-list" element={<DeletedUsersList />} />
          <Route exact path="/subscribers" element={<Subscribers />} />
          <Route path="/" element={<Navigate to="/userlisting" />} />
          <Route exact path="/userlisting" element={<UsersListing />} />
          <Route exact path="/channel" element={<ChannelManagement />} />
          <Route exact path="/addTheme" element={<AddTheme />} />
          <Route exact path="/eventmanagement" element={<Eventmanagement />} />
          <Route exact path="/testing" element={<DropdownWithEditDelete />} />
          <Route exact path="/homeautomation" element={<HomeAutomation />} />
          <Route path="/userlisting/view/:id" element={<ViewUsers />} />
          <Route path="/channel/view/:id" element={<ChannelView />} />

          {/* <Route path="/banners/TVBanners" element={<TVBanner />} /> */}
          {/* <Route path="/banners/AppBanners" element={<Banners />} /> */}
          <Route path="/banners/TVSlider" element={<TVSlider />} />
          <Route path="/adsBanner" element={<AdsBanner />} />

          {/* <Route path="/Advertisement/TVAdBanners" element={<AdTVBanner />} />
          <Route path="/Advertisement/AppAdBanners" element={<AdBanners />} /> */}

          {/* <Route path="/packageListing" element={<PackageListing />} />
          <Route path="/media/genreListing" element={<GenreListing />} />
          <Route path="/media/languages" element={<Languages />} />
          <Route path="/media/broadcaster" element={<Broadcaster />} />
          <Route path="/media/categories" element={<Categories />} /> */}
          <Route path="/PrivacyPolicy" element={<PrivacyPolicy />} />
          <Route path="/TermsConditions" element={<TermsConditions />} />
          <Route path="/About_Us" element={<AboutUsPage />} />
          {/* tushar- this route is used for channel category */}
          <Route path="/chanelCategory" element={<ChannelCategory />} />
          {/*   this  route is for free live channel */}
          {<Route path="/freeLive" element={<FreeLiveChannelList />} />}
          {/* {Route path="/add"} */}
          {<Route path="/app-version" element={<AppVersionList />} />}
          {
            <Route
              path="/app-version-mobile"
              element={<AppVersionMobileList />}
            />
          }
          {/* <Route exact path="/testing" element={<div>Test Route</div>} /> */}

          {/* <================================================= Saket =============================================> */}

          {/* routes for channelLanguage */}
          {<Route path="/channelLanguage" element={<ChannelLanguageList />} />}
          <Route
            path="/add-channel-language"
            element={<AddChannelLanguage />}
          />

          {/* IPTV Channels Route */}
          <Route path="/iptv/channels" element={<IptvChannelList />} />

          {/* IPTV User Requests Route */}
          <Route path="/iptv/user-requests" element={<IptvUserRequest />} />

          {/* Dashboard */}
          <Route path="/dashboard" element={<Dashboard />} />

          {/* OTT */}
          <Route path="/ottHub" element={<OttContent />} />
          {/* Security Check */}
          {/* <Route path="/securityCheck" element={<SecurityCheck />} /> */}
        </Route>
        <Route path="*" element={<WrongPath />} />
      </Routes>
    </>
  );
};
